import Overview from './overview.vue';
import Full from '@rebuild/materials/shared/us_announcement/Full.vue';

export const componentMap = {
	overview: Overview,
	full: Full
};
